import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1040"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M6.635 11.467H5.379l.628-1.087a.7.7 0 0 0-1.213-.701l-.627 1.087-.628-1.087a.701.701 0 0 0-1.213.701l.628 1.087H1.698a.7.7 0 1 0 0 1.4h1.256l-.628 1.087a.701.701 0 0 0 1.213.701l.627-1.087.627 1.087a.7.7 0 0 0 .956.256.701.701 0 0 0 .257-.957l-.628-1.087h1.256a.7.7 0 1 0 .001-1.4zm7.668 0h-1.256l.628-1.087a.701.701 0 0 0-1.213-.701l-.627 1.087-.627-1.087a.7.7 0 1 0-1.213.701l.628 1.087H9.366a.7.7 0 1 0 0 1.4h1.256l-.628 1.087a.701.701 0 0 0 1.213.701l.627-1.087.627 1.087a.7.7 0 0 0 .956.256.701.701 0 0 0 .257-.957l-.628-1.087h1.256a.7.7 0 1 0 .001-1.4zM9.738 8.586a.701.701 0 0 0 .606-1.051L9.156 5.479h2.376a.7.7 0 1 0 0-1.4H9.156l1.188-2.057a.701.701 0 0 0-1.213-.701L7.943 3.378 6.756 1.321a.7.7 0 0 0-1.213.7l1.188 2.057H4.355a.7.7 0 1 0 0 1.4H6.73L5.543 7.536a.701.701 0 0 0 1.213.701L7.944 6.18l1.188 2.057a.698.698 0 0 0 .606.349z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }